import React, { useContext } from "react";
import styles from "./Conclusion.module.scss";
import PathContext from "../../context/path";
import clsx from 'clsx';

const Conclusion = (props) => {
  const { img, text, use, className } = props;
  const path = useContext(PathContext);
  let texts = [];
  let classWrap = `${styles.wrap}`;
  if (text !== undefined && text.length > 0) {
    text.forEach((element, index) => {
      texts.push(<p key={`text-${index}`}>{element}</p>);
    });

  }
  if (use !== undefined && styles[`wrap_${use}`] !== undefined) {
    classWrap += ` ${styles[`wrap_${use}`]}`;
  }
  return (
    <>
      <div className={clsx(classWrap, className)}>
        <div className={styles.inner}>
          <div className={styles.person}>
            <div className={styles.img}>
              
          <picture>
            <source media="(min-width: 1921px)" srcSet={`${path}/img/${img}@2x.webp`} />
            <source media="screen and (max-width: 767px)" srcSet={`${path}/img/${img}-mobile.webp, ${path}/img/${img}-mobile@2x.webp 2x`} />
            <img src={`${path}/img/${img}.webp`} srcSet={`${path}/img/${img}@2x.webp 2x`} alt="" />
          </picture>
            </div>
            <div className={styles.name}>
              {props.children}
            </div>
          </div>
          <div className={styles.text} data-animate={'fade-in-up'}>
            {texts}
          </div>
        </div>
      </div>
    </>
  );

}

export default Conclusion;
